module.exports = __webpack_public_path__ + "img/1000liters to 1bakkie.35c1f16d.svg";